import {
  Property,
  PropertyGroup,
  PropertyGroupListItem,
  PropertyListItem,
} from 'types';

export type FormMode = 'edit' | 'create' | 'wizard' | 'none';
export type DisplayMode = 'property' | 'group' | 'tenant';

export interface PanelRootContext<T> {
  entity: T;
  setEntity: (entity: T) => void;
  displayMode: DisplayMode;
  formMode: FormMode;
  setFormMode: (mode: FormMode) => void;
  properties?: Property[] | PropertyListItem[];
  propertyGroups?: PropertyGroup[] | PropertyGroupListItem[];
}

export enum EntityPanelActionHandler {
  NONE = 'NONE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  PROPERTY_CREATE = 'PROPERTY CREATE',
  PROPERTY_UPSERT = 'PROPERTY UPSERT',
  GROUP_CREATE = 'GROUP CREATE',
  GROUP_UPSERT = 'GROUP UPSERT',
  TENANT_CREATE = 'TENANT CREATE',
  TENANT_UPDATE = 'TENANT UPDATE',
}

export interface TraxeroActionResponse<T, B = any> {
  handler: T;
  status: number;
  statusText: string;
  body?: B;
  response?: any;
  message?: string;
}
